import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { MapView } from './pages/MapView';
import { StationsView } from './pages/StationsView';
import { ForecastView } from './pages/ForecastView';
import { EnergyMarketView } from './pages/EnergyMarketView';
import { WorkspacesView } from './pages/WorkspacesView';
import { AccountSettingsView } from './pages/AccountSettingsView';
import { OverviewView } from './pages/OverviewView';
import { IntradayTraderView } from './pages/IntradayTraderView';
import { WorkspacesOverviewView } from './pages/WorkspacesOverviewView';
import { TemplateView } from './pages/TemplateView';
import { NotificationsView } from './pages/NotificationsView';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { OnboardingView } from './pages/OnboardingView';
import { AthenaDiscoveryView } from './pages/AthenaDiscoveryView';
import { AthenaView } from './pages/AthenaView';
import { WorkspacesProvider } from './hooks/useWorkspaces';
import { ChatProvider } from './hooks/useChatHistory';
import { UserProfileProvider } from './hooks/useUserProfile';
import { NotificationsProvider } from './hooks/useNotifications';
import { AlertRulesProvider } from './hooks/useAlertRules';
import { CreateAlertView } from './pages/CreateAlertView';
import { AlertRulesView } from './pages/AlertRulesView';
export function App() {
  return <HashRouter data-id="element-0">
      <UserProfileProvider data-id="element-1">
        <NotificationsProvider data-id="element-2">
          <AlertRulesProvider data-id="element-3">
            <WorkspacesProvider data-id="element-4">
              <ChatProvider data-id="element-5">
                <Routes data-id="element-6">
                  {/* Public routes outside AppLayout */}
                  <Route path="/" element={<HomePage data-id="element-8" />} data-id="element-7" />
                  <Route path="/login" element={<LoginPage data-id="element-10" />} data-id="element-9" />
                  <Route path="/onboarding" element={<OnboardingView data-id="element-12" />} data-id="element-11" />
                  <Route path="/athena-discovery" element={<AthenaDiscoveryView data-id="element-14" />} data-id="element-13" />

                  {/* Authenticated routes inside AppLayout */}
                  <Route element={<AppLayout data-id="element-16" />} data-id="element-15">
                    <Route path="/overview" element={<OverviewView data-id="element-18" />} data-id="element-17" />
                    <Route path="/athena" element={<AthenaView data-id="element-20" />} data-id="element-19" />
                    <Route path="/home" element={<Navigate to="/" replace data-id="element-22" />} data-id="element-21" />
                    <Route path="/workspace/:id" element={<WorkspacesView data-id="element-24" />} data-id="element-23" />
                    <Route path="/template/:id" element={<TemplateView data-id="element-26" />} data-id="element-25" />
                    <Route path="/map" element={<MapView data-id="element-28" />} data-id="element-27" />
                    <Route path="/stations" element={<StationsView data-id="element-30" />} data-id="element-29" />
                    <Route path="/energy" element={<EnergyMarketView data-id="element-32" />} data-id="element-31" />
                    {/* Intraday Trader hidden */}
                    <Route path="/settings" element={<AccountSettingsView data-id="element-34" />} data-id="element-33" />
                    <Route path="/notifications" element={<Navigate to="/alerts" replace data-id="element-36" />} data-id="element-35" />
                    <Route path="/alerts/create" element={<CreateAlertView data-id="element-38" />} data-id="element-37" />
                    <Route path="/alerts" element={<AlertRulesView data-id="element-40" />} data-id="element-39" />
                    <Route path="/workspaces" element={<WorkspacesOverviewView data-id="element-42" />} data-id="element-41" />

                    {/* Redirects/Placeholders for other routes */}
                    <Route path="/status" element={<div className="p-8 text-slate-400" data-id="element-44">
                          Dissemination Status View (Placeholder)
                        </div>} data-id="element-43" />
                    <Route path="/docs" element={<div className="p-8 text-slate-400" data-id="element-46">
                          Documentation View (Placeholder)
                        </div>} data-id="element-45" />
                    {/* Catch-all → Athena for authenticated users */}
                    <Route path="*" element={<Navigate to="/athena" replace data-id="element-48" />} data-id="element-47" />
                  </Route>
                </Routes>
              </ChatProvider>
            </WorkspacesProvider>
          </AlertRulesProvider>
        </NotificationsProvider>
      </UserProfileProvider>
    </HashRouter>;
}